import { HeaderNavigation } from '@/components/header/HeaderNavigation';
import { Footer } from '@/components/layout/Footer';
import { type ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className='min-h-screen bg-background flex flex-col'>
      <HeaderNavigation />
      <main className='container mx-auto px-4 py-8 flex-1 w-full'>{children}</main>
      <Footer />
    </div>
  );
};
